<div
    class="section-wrapper is-header"
    [class.is-header]="isHeader()"
    [class.is-estate]="!isHeader()"
    [class.collapsed]="!showDetails()"
    [class.in-market]="searchViewOptions().periodDefinitionType === periodType.InMarket"
>
    @if (searchViewOptions().periodDefinitionType !== periodType.Sold) {
        <div class="count-row count-separator counter-spacing">
            <div class="flex-coloumn">
                <div class="flex-coloumn">
                    <div class="primary-color uppercase-text">Solgt</div>
                    <div class="secondary-color uppercase-text">i perioden</div>
                </div>
                <div class="big-number">{{ statistics().soldInPeriod | thousandize }}</div>
            </div>
            <div class="flex-coloumn">
                <div class="flex-coloumn">
                    <div class="primary-color uppercase-text">Solgt</div>
                    <div class="secondary-color uppercase-text">etter perioden</div>
                </div>
                <div class="big-number">{{ statistics().soldAfterPeriod | thousandize }}</div>
            </div>
        </div>
    }
    <div class="count-card" [class.top]="showDetails()">
        @if (showDetails()) {
            <div class="count-row top">
                <div class="primary-color">Snitt salgspriser</div>
            </div>
        }
        <div class="count-row">
            <div class="secondary-color">m² BRA-i/P-rom</div>
            <div class="primary-color">{{ statistics().squareMeterPriceSold | thousandize }}</div>
        </div>
        <div class="count-row">
            <div class="secondary-color">m² BRA</div>
            <div class="primary-color">{{ statistics().squareMeterPriceBraSold | thousandize }}</div>
        </div>
        <div class="count-row">
            <div class="secondary-color">Pris</div>
            <div class="primary-color">{{ statistics().averagePriceSold | thousandize }}</div>
        </div>
        @if (isHeader() || showDetails()) {
            <div class="air">
                <div class="count-row">
                    <div class="secondary-color">Omsetningshastighet</div>
                    <div class="primary-color">{{ statistics().saleTime | pluralizer: "dag" : "dager" }}</div>
                </div>
                <div class="count-row">
                    <div class="secondary-color">Avvik pris/prisant</div>
                    <div class="primary-color">
                        @if (statistics().averagePricePriceAssumptionDiff === null) {
                            -
                        } @else {
                            {{ statistics().averagePricePriceAssumptionDiff | percent: "1.0-1" }}
                        }
                    </div>
                </div>
                @if (statistics().averagePricePriceAssumptionDiffFromFirst) {
                    <div
                        class="count-row"
                        [class.last-row]="
                            (searchViewOptions().periodDefinitionType !== periodType.Sold && showDetails && !statistics()?.layTime) ||
                            (isHeader() && !statistics()?.layTime)
                        "
                    >
                        <div class="secondary-color">Avvik pris/oppr prisant</div>
                        <div class="primary-color">{{ statistics().averagePricePriceAssumptionDiffFromFirst | percent: "1.0-1" }}</div>
                    </div>
                }
                @if (statistics().layTime && searchViewOptions().periodDefinitionType !== periodType.Sold) {
                    <div class="count-row last-row">
                        <div class="secondary-color">Liggetid</div>
                        <div class="primary-color">{{ statistics().layTime | pluralizer: "dag" : "dager" }}</div>
                    </div>
                }
            </div>
        }
    </div>
</div>
@if (searchViewOptions().periodDefinitionType !== periodType.Sold && showDetails()) {
    <div class="section-wrapper" [class.is-header]="isHeader()"
    [class.is-estate]="!isHeader()" >
        <div class="count-row count-separator counter-spacing">
            <div class="flex-coloumn">
                <div class="primary-color uppercase-text">Til salgs nå</div>
                <div class="big-number">{{ statistics().forSale | thousandize }}</div>
            </div>
            <div class="flex-coloumn">
                <div class="primary-color uppercase-text">Trukket</div>
                <div class="big-number">{{ statistics().withdrawn | thousandize }}</div>
            </div>
        </div>
    </div>
}

<div class="section-wrapper" [class.is-header]="isHeader()"
    [class.is-estate]="!isHeader()" >
    <ev-range-indicator [overPercentage]="soldOverPercentage" [underPercentage]="soldUnderPercentage" title="PRIS VS PRISANTYDNING"></ev-range-indicator>
</div>
